"use strict";
/**
 * @file 地图类型控件
 * @author hedongran
 * @email hdr01@126.com
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Control_1 = tslib_1.__importDefault(require("./Control"));
/**
 * 地图类型控件，默认位于地图右上角
 * @visibleName MapTypeControl 地图类型控件
 */
var MapTypeControl = /** @class */ (function (_super) {
    tslib_1.__extends(MapTypeControl, _super);
    function MapTypeControl(props) {
        return _super.call(this, props) || this;
    }
    MapTypeControl.prototype.getControl = function () {
        return new BMapGL.MapTypeControl(this.getOptions());
    };
    MapTypeControl.prototype.render = function () {
        return null;
    };
    return MapTypeControl;
}(Control_1.default));
exports.default = MapTypeControl;
